import styled from 'styled-components';
import { LayoutItem, type LayoutItemProps } from '@oneaudi/unified-web-components';
import type React from 'react';
import { type HTMLAttributes } from 'react';

export type LayoutContainerProps = HTMLAttributes<HTMLDivElement> & LayoutItemProps;
export const LayoutContainer = styled<React.FC<LayoutContainerProps>>(LayoutItem)``;
